import { render } from "./GridDemo.vue?vue&type=template&id=0a09763b"
import script from "./GridDemo.vue?vue&type=script&lang=js"
export * from "./GridDemo.vue?vue&type=script&lang=js"

import "./GridDemo.vue?vue&type=style&index=0&id=0a09763b&lang=scss"

import exportComponent from "G:\\desarrollo\\frontend\\gsobservatorio-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__